
import createIconComponent from './utils/createIconComponent';
import React from 'react';
var IconArrowCircleDown = createIconComponent({ fillContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M12 0a12 12 0 1 0 12 12A12.013 12.013 0 0 0 12 0zm6.992 9.615l-5.634 7.346a1.711 1.711 0 0 1-2.716 0L5.008 9.615a1.25 1.25 0 1 1 1.984-1.521l4.81 6.271a.249.249 0 0 0 .4 0l4.81-6.271a1.25 1.25 0 1 1 1.984 1.521z' })
  ), lightContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M12 24C5.383 24 0 18.617 0 12S5.383 0 12 0s12 5.383 12 12-5.383 12-12 12zm0-23C5.935 1 1 5.935 1 12s4.935 11 11 11 11-4.935 11-11S18.065 1 12 1z' }),
    React.createElement('path', { d: 'M11.999 17.196a.99.99 0 0 1-.796-.392l-6.1-7.954a.502.502 0 0 1 .093-.701.497.497 0 0 1 .701.092l6.1 7.955 6.1-7.957a.496.496 0 0 1 .701-.093.499.499 0 0 1 .093.701l-6.1 7.957a.988.988 0 0 1-.792.392z' })
  ), regularContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M12 24C5.383 24 0 18.617 0 12S5.383 0 12 0s12 5.383 12 12-5.383 12-12 12zm0-22.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5z' }),
    React.createElement('path', { d: 'M12.002 17.353c-.516 0-.99-.259-1.267-.693L6.117 9.403c-.107-.169-.143-.37-.099-.566a.745.745 0 0 1 .732-.587c.258 0 .495.13.633.347L12 15.853l4.617-7.256a.748.748 0 0 1 1.035-.23.751.751 0 0 1 .23 1.036l-4.617 7.256a1.494 1.494 0 0 1-1.263.694z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconArrowCircleDown.displayName = 'IconArrowCircleDown';
export default IconArrowCircleDown;